function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M6.515 1.82l.793-.783a.86.86 0 011.21 0L15.462 7.9a.838.838 0 010 1.197l-6.942 6.867a.86.86 0 01-1.21 0l-.794-.784a.842.842 0 01.015-1.212l4.303-4.055H.57a.85.85 0 01-.857-.848v-1.13a.85.85 0 01.857-.848h10.263L6.53 3.032a.836.836 0 01-.015-1.211z",
  fill: "#F1FAFF"
});

function SvgIconArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 17",
    fill: "none"
  }, props), _ref);
}

export default SvgIconArrow;